import { colors, gap, radius, RoundButton, spacing } from '@lamimed/pantheon';
import styled, { css } from 'styled-components';
import { scrollbarTheme } from 'styles/scrollbar';

const opacityAnimation = () => css`
  @keyframes opacityAnim {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  animation: opacityAnim 3s ease 0s infinite normal forwards;
`;

export const Wrapper = styled.div`
  section {
    padding: ${spacing.medium};

    > div {
      background-color: transparent;
      max-width: 60rem;
      padding: ${spacing.none};
      min-height: auto;
    }
  }
`;

export const FileBoxContainer = styled.div`
  width: 100%;
`;

export const DownloadDocumentButton = styled(RoundButton)`
  span {
    display: flex;
    align-items: center;
    justify-content: center;

    ${gap(spacing.small)}
  }
`;

export const DownloadButtonWrapper = styled.div`
  display: flex;
  align-items: end;
  justify-content: center;
  width: 100%;
  margin-top: ${spacing.medium};
`;

export const ScrollWrapper = styled.div`
  background-color: ${colors.light};
  margin-bottom: ${spacing.medium};
  border-radius: ${radius.small};
  padding: ${spacing.small};
`;

export const ImageWrapper = styled.div<{ loading: boolean }>`
  max-height: 40rem;
  overflow-y: auto;
  padding: calc(${spacing.small} / 2);

  ${({ loading }) =>
    loading &&
    css`
      height: 35rem;
      overflow-y: unset;
      background-position: center;
      background-image: url('/images/loading-file.svg');
      background-repeat: no-repeat;
      background-size: 20rem;

      ${opacityAnimation()}
    `};

  img {
    position: initial !important;

    /* NOTE: This is a mocked px value to improve the img visibility */
    border-radius: 0.6rem;

    object-fit: contain;
  }

  ${({ theme }) => scrollbarTheme(theme)};
`;
